const state = {
    tokenContribuyente: null,
    datosPago: null,
    parcialidades: null,
    totalLiquidacion: null,
    isCalculando: false,
    isGenerando: false,
    idxUltParcialidad: 99,
    msgErrorContribuyente: '',
    msgErrorGenLinea: '',
    catalogContribuyente:{
        terminosServicio:"Terminos y Condiciones del Servicio.",
        thems:{
            teotihuacan:"teotihuacan",
            demo:"demo"
        }
    },
    test:[
        {"periodo":"JUL-JUL 2020",
        "importe":"200.00",
        "recargo":"0.00",
        "multa":"0.00",
        "pae":"0.00",
        "subsidios":"0.00",
        "total":"200.00",
        "pagar":true,
        "detalles":"Tipo de documento/servicio:27.II.B. Celebración de matrimonio en oficialía en días y horas inhábiles\nNo. de trabajos/servicios:1"
        },
        {"periodo":"JUL-JUL 2020",
        "importe":"200.00",
        "recargo":"0.00",
        "multa":"0.00",
        "pae":"0.00",
        "subsidios":"0.00",
        "total":"200.00",
        "pagar":true,
        "detalles":"Tipo de documento/servicio:27.II.B. Celebración de matrimonio en oficialía en días y horas inhábiles\nNo. de trabajos/servicios:1"
        }
    ]
}

// mutations
const mutations = {
    updateMsgErrorGenLinea(state, newMsgErrorGenLinea){
        state.msgErrorGenLinea = newMsgErrorGenLinea;
    },
    updateMsgErrorContribuyente(state, newMsgErrorContribuyente){
        state.msgErrorContribuyente = newMsgErrorContribuyente;
    },
    updateParcialidadesContribuyente (state, newParcialidadesContribuyente){
        state.parcialidades = newParcialidadesContribuyente;
    },
    updateDatosPagoContribuyente (state, newDatosPagoContribuyente){
        state.datosPago = newDatosPagoContribuyente;
    },
    updateTotalLiquidacionContribuyente (state, newTotalLiquidacionContribuyente){
        state.totalLiquidacion = newTotalLiquidacionContribuyente;
    },
    updateIsCalculandoContribuyente (state, newIsCalculando){
        state.isCalculando = newIsCalculando;
    },
    updateIsGenerandoContribuyente (state, newIsGenerando){
        state.isGenerando = newIsGenerando;
    },
    updateIdxUltParcialidadContribuyente (state, newIdxUltParcialidad){
        state.idxUltParcialidad = newIdxUltParcialidad;
    }
}

export default {
    state,
    mutations
}